import { RadioGroup, type RadioProps, RadioTile } from '@/components/common/radio'
import { VALID_APY_RANGES, useSettingsContext } from '@/context/settings'
import { getApyRangeCopy } from '@/utils/apy'
import { cn } from '@/utils/cn'

type ApyRangeSettingsSelectorProps = Omit<RadioProps, 'value' | 'onValueChange'>

export const ApyRangeSettingsSelector = ({ className, ...props }: ApyRangeSettingsSelectorProps) => {
  const { apyRange, handleApyRange } = useSettingsContext()

  return (
    <RadioGroup
      value={apyRange}
      onValueChange={handleApyRange}
      className={cn('grid grid-cols-3', className)}
      aria-label="Show APY as average of"
      {...props}
    >
      {VALID_APY_RANGES.map((range) => (
        <RadioTile key={range} value={range}>
          {getApyRangeCopy(range).full}
        </RadioTile>
      ))}
    </RadioGroup>
  )
}
